import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import ExtractPDFContent from './extract-pdf-content.md';
import CreatePDF from './create-pdf.md';
import DocumentGeneration from './document-generation.md';
import ConvertPDF from './convert-pdf.md';
import OcrPDF from './ocr-pdf.md';
import SecurePDF from './secure-pdf.md';
import RemovePDFPassword from './remove-pdf-password.md';
import GetPDFProperties from './get-pdf-properties.md';
import CheckPDFAccessibility from './check-pdf-accessibility.md';
import PDFWatermark from './pdf-watermark.md';
import SplitPDF from './split-pdf.md';
import CombinePDF from './combine-pdf.md';
import CompressPDF from './compress-pdf.md';
import ReorderPDFPages from './reorder-pdf-pages.md';
import LinearizePDF from './linearize-pdf.md';
import InsertPDFPages from './insert-pdf-pages.md';
import ReplacePDFPages from './replace-pdf-pages.md';
import DeletePDFPages from './delete-pdf-pages.md';
import RotatePDFPages from './rotate-pdf-pages.md';
import HTMLToPDF from './html-to-pdf.md';
import AccessibilityAutoTagApi from './accessibility-auto-tag-api.md';
import EsealAPI from './e-seal.md';
import ExportFormData from './export-pdf-form-data.md';
import ImportFormData from './import-pdf-form-data.md';
import './key-features-code-block.css';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    {/* Key Features of Adobe PDF Services API */}
    <DCSummaryBlock slots="heading, buttons" background="rgb(31, 42, 73)" buttonPositionRight className="key-features-code-block" mdxType="DCSummaryBlock" />
    <h2 {...{
      "id": "key-features-of-adobe-pdf-services-api"
    }}>{`Key features of Adobe PDF Services API`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-services-api"
        }}>{`Start for free`}</a></li>
    </ul>
    <TabsBlock orientation="vertical" slots="heading, image, content" repeat="24" theme="dark" className='bgBlue code-block-0 key-features-code-block service-code-block tabBlockAlign' mdxType="TabsBlock" />
    <h3 {...{
      "id": "extract-pdf-content"
    }}>{`Extract PDF Content`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/0858b7a490f1a3353fcfcd59fc60aaf8/s_createpdf_color_24.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <ExtractPDFContent mdxType="ExtractPDFContent" />
    <h3 {...{
      "id": "auto-tag-pdf"
    }}>{`Auto-tag PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/b6c3cc7037a76c92f575ebf35bbae1d9/autotagIcon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <AccessibilityAutoTagApi mdxType="AccessibilityAutoTagApi" />
    <h3 {...{
      "id": "create-pdf"
    }}>{`Create PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/0858b7a490f1a3353fcfcd59fc60aaf8/s_createpdf_color_24.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <CreatePDF mdxType="CreatePDF" />
    <h3 {...{
      "id": "html-to-pdf"
    }}>{`HTML to PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/5d788279f499e9f2c61c9a5ccef2bbfc/s_html-to-pdf.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <HTMLToPDF mdxType="HTMLToPDF" />
    <h3 {...{
      "id": "document-generation"
    }}>{`Document Generation`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/3dfca3c81abfd73b5308fcabba5246aa/ic-dynamic-pdf-gen-40.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <DocumentGeneration mdxType="DocumentGeneration" />
    <h3 {...{
      "id": "electronically-seal-pdf"
    }}>{`Electronically Seal PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/95b700b3876491cea4394b2bfe3e6ac3/electronic-seal.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <EsealAPI mdxType="EsealAPI" />
    <h3 {...{
      "id": "convert-pdf"
    }}>{`Convert PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/3d31f35ca6a526014e4f0f164c1371ec/export_page.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <ConvertPDF mdxType="ConvertPDF" />
    <h3 {...{
      "id": "ocr-pdf"
    }}>{`OCR PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/fcfe4f5ba6f8b66c15353fef465e6332/recognize_text.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <OcrPDF mdxType="OcrPDF" />
    <h3 {...{
      "id": "secure-pdf"
    }}>{`Secure PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/62a0455fdd1b8f1d3829edd4cde485a8/s_protect_24.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <SecurePDF mdxType="SecurePDF" />
    <h3 {...{
      "id": "remove-pdf-password"
    }}>{`Remove PDF Password`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/946603b94a27a591568caef798423730/s_unlock-pdf_22.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <RemovePDFPassword mdxType="RemovePDFPassword" />
    <h3 {...{
      "id": "get-pdf-properties"
    }}>{`Get PDF Properties`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/1e5446d272110b47678a74804fbb054e/s_properties_22.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <GetPDFProperties mdxType="GetPDFProperties" />
    <h3 {...{
      "id": "pdf-accessibility-checker"
    }}>{`PDF Accessibility Checker`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/c7192fdecf4432f05d90947dbd7460ad/accesiblity_check.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <CheckPDFAccessibility mdxType="CheckPDFAccessibility" />
    <h3 {...{
      "id": "pdf-watermark"
    }}>{`PDF Watermark`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "57px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "119.29824561403508%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/b8f4f0770af3efe4038ae9c137bd3e6e/689c9/watermark_pdf_icon.webp 57w"],
            "sizes": "(max-width: 57px) 100vw, 57px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/b8f4f0770af3efe4038ae9c137bd3e6e/3cdff/watermark_pdf_icon.png 57w"],
            "sizes": "(max-width: 57px) 100vw, 57px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/b8f4f0770af3efe4038ae9c137bd3e6e/3cdff/watermark_pdf_icon.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <PDFWatermark mdxType="PDFWatermark" />
    <h3 {...{
      "id": "split-pdf"
    }}>{`Split PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/624df226156e9aeef0bead31b2908b5e/s_split-pdf_22.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <SplitPDF mdxType="SplitPDF" />
    <h3 {...{
      "id": "combine-pdf"
    }}>{`Combine PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/97d30119e3360370db944e08832c0bf9/s_combinefiles_color_24.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <CombinePDF mdxType="CombinePDF" />
    <h3 {...{
      "id": "compress-pdf"
    }}>{`Compress PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/6eba1c7aa888ec9a16c52a514e92205b/compress_pdf.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <CompressPDF mdxType="CompressPDF" />
    <h3 {...{
      "id": "reorder-pdf-pages"
    }}>{`Reorder PDF Pages`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/610fad89aac848cc4d99537d9697048a/reorder_page.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <ReorderPDFPages mdxType="ReorderPDFPages" />
    <h3 {...{
      "id": "linearize-pdf"
    }}>{`Linearize PDF`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/279603a288e440edd8f1e8f8e8008f56/linearize_pdf.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <LinearizePDF mdxType="LinearizePDF" />
    <h3 {...{
      "id": "insert-pdf-pages"
    }}>{`Insert PDF Pages`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/99bf149a874830ed9bebd534c11eb005/insert_page.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <InsertPDFPages mdxType="InsertPDFPages" />
    <h3 {...{
      "id": "replace-pdf-pages"
    }}>{`Replace PDF Pages`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/d8ed619d131b96bf14481c71ad2ca298/replace_page.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <ReplacePDFPages mdxType="ReplacePDFPages" />
    <h3 {...{
      "id": "delete-pdf-pages"
    }}>{`Delete PDF Pages`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/22ffda818c1b228556c87bab7fc6c6b3/delete_page.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <DeletePDFPages mdxType="DeletePDFPages" />
    <h3 {...{
      "id": "rotate-pdf-pages"
    }}>{`Rotate PDF Pages`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/241c87ad01f345a65ad6d9ac175a042f/rotate_page.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <RotatePDFPages mdxType="RotatePDFPages" />
    <h3 {...{
      "id": "import-pdf-form-data"
    }}>{`Import PDF Form Data`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/0858b7a490f1a3353fcfcd59fc60aaf8/s_createpdf_color_24.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <ImportFormData mdxType="ImportFormData" />
    <h3 {...{
      "id": "export-pdf-form-data"
    }}>{`Export PDF Form Data`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/0858b7a490f1a3353fcfcd59fc60aaf8/s_createpdf_color_24.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <ExportFormData mdxType="ExportFormData" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      